import { Component, AfterViewChecked, OnInit, OnDestroy, ViewChildren, QueryList, ElementRef, AfterViewInit } from '@angular/core';
import * as feather from 'feather-icons';
import { Plan } from '../common/models/plan';
import { ActivityService } from '../common/services/activity.service';
import { Activity } from '../common/models/activity';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { PlanEditService } from '../common/services/plan-edit.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanService } from '../common/services/plan.service';
import { SharedService } from '../common/services/shared.service';
import { MemberProfile } from '../common/models/profile';
import { UserService } from '../common/services/user.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-track-progress',
    templateUrl: './track-progress.component.html',
    styleUrls: ['./track-progress.component.css'],
    standalone: false
})
export class TrackProgressComponent implements OnInit, AfterViewChecked, OnDestroy, AfterViewInit {

  plan: Plan;
  profile: MemberProfile;
  c_percent: number;

  paramsSubscription: Subscription;

  onDestroy$: Subject<boolean> = new Subject()

  activityNotes = new Subject<Activity>();
  statusChange = new Subject<Activity>();
  dateChange = new Subject<Activity>();
  EmailReminderOn = new Subject<Activity>();
  buttonDisabled = false;
  minDate = new Date();

  @ViewChildren('reopen', { read: ElementRef })
  buttons: QueryList<ElementRef<HTMLButtonElement>>;

  @ViewChildren('text', { read: ElementRef })
  text: QueryList<ElementRef<HTMLTextAreaElement>>;

  constructor(
    private activityService: ActivityService,
    private _snackBar: MatSnackBar,
    private planService: PlanService,
    private planEditService: PlanEditService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private userService: UserService) {
  }

  ngAfterViewInit(): void {
    this.activityNotes.pipe(debounceTime(500)).subscribe(r => {
      this.buttonDisabled = true;
      const scrubbedActivity = this.activityService.scrubActivity(r);
      this.activityService.putActivity(scrubbedActivity).subscribe(() => {
        this.buttonDisabled = false;
      });
    });
    this.statusChange.subscribe(r => {
      this.buttonDisabled = true;
      if(r.Status !== 2)
        r.CompletedOn = null;

      this.activityService.putActivity(r).subscribe(() => {
        this.buttonDisabled = false;
        this.updateProgress();
      })
    });
    this.dateChange.subscribe(r => {
        this.buttonDisabled = true;
        this.activityService.putActivity(r).subscribe(() => {
          this.buttonDisabled = false;
        });
    });
  }

  openSnackbarError(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: message, panelClass: 'snackbar-error'
    });
  }

  updateProgress() {
    let total = 0;
    let completed = 0;
    this.plan?.Competencies?.forEach(function (competency) {
      competency.Activities?.forEach(function (activity) {
        total++;
        if (activity.Status === 2) {
          completed++;
        }
      });
    });
    if (completed == 0)
      this.c_percent = 0
    else
      this.c_percent = Math.ceil((completed / total) * 100);
  }

  ngOnInit(): void {
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.paramsSubscription = this.route.params.subscribe(params => {
      this.planService.getPlan(params['id']).subscribe({
        next: (p) => {
          this.plan = p;
          this.updateProgress();
          this.userService.profile().subscribe({next: (profile) => this.profile = profile});
        }
      })
    });
  }

  ngAfterViewChecked() {
    feather.replace();
  }

  completeActivity(activity: Activity, index: string) {
    activity.CompletedOn = new Date();
    this.saveActivity(activity);
    this.updateProgress();
    this.focusButton(index);
  }

  saveDraftActivity(activity: Activity) {
    activity.CompletedOn = null;
    this.saveActivity(activity);
  }

  reopenActivity(activity: Activity, index: string) {
    activity.CompletedOn = null;
    this.saveActivity(activity);
    this.updateProgress();
    this.focusText('text'+index);
  }

  saveActivity(activity: Activity) {
    const scrubbedActivity = this.activityService.scrubActivity(activity);
    this.activityService.putActivity(scrubbedActivity).subscribe({
      next: (a) => {
        const competency = this.plan.Competencies.find(r => r.Id == activity.CompetencyId);
        competency.Activities.find(r => r.Id == activity.Id).CompletedOn = a.CompletedOn;
      },
      error: () => this.openSnackbarError("Unable to save changes.")
    });
  }

  addActivity() {
    this.planEditService.setIsEditing(true, 6, this.plan.PlanYear);
    this.router.navigateByUrl('app/selfassessment');
  }

  focusButton(index: string): void {
    setTimeout(() => {
      this.buttons.forEach((item) => {
      if(item.nativeElement.name == index){
        item.nativeElement.focus();
      }
    });
    }, 500);
  }

  focusText(index: string) {
    setTimeout(() => {
      this.text.forEach((item) => {
      if(item.nativeElement.name === index){
        item.nativeElement.focus();
      }
    });
    }, 500);
  }

  onClick(): void {
    if(this.plan.IsEditable)
      this.planService.updatePlan(this.plan).subscribe();
  }

  onCheckboxChange(event: MatCheckboxChange, activity: Activity) {
    if(!event.checked){
      this.buttonDisabled = true;
      activity.EmailReminderOn = null;
      this.activityService.putActivity(activity).subscribe(() =>{
        this.buttonDisabled = false
      });
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
}
